import React from 'react';
import NoData from 'components/_common/NoData';
import Loading from 'components/_common/Loading';
import SearchFilter from 'components/_common/SearchFilter';
import PageUtil from 'utils/Page.util';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { getDateType, getReceptionType, ReceptionType, ReceptionItemKind } from 'enums/reception.enum';

const RepairStatisticsV = ({
    params,
    setParams,
    onSearch,
    setSearch,
    onClearFilter,
    onClearManufactureMonthFilter,
    onOpenCreate,
    onOpenEdit,
    onModalSave,
    onModalClose,
    handleExportExcel,
}) => {
    const { list, isLoaded, error, search, kpiLoaded, kpiData } = params;

    const dateTypeOptions = getDateType();

    const handleSearchChange = (field, value) => {
        const cur = PageUtil.deepCopy(params);
        if (field === 'startDate' || field === 'endDate') {
            cur.search[field] = value;
        } else {
            cur.search[field] = value;
        }
        setParams(cur);
    };

    const KPISkeleton = () => (
        <div className="mb-4">
            <div className="row g-3 mb-4">
                {[1, 2, 3, 4, 5, 6, 7].map(i => (
                    <div key={i} className="col-md-2">
                        <div className="card">
                            <div className="card-body">
                                <div className="placeholder-glow">
                                    <span className="placeholder col-8"></span>
                                </div>
                                <div className="placeholder-glow mt-2">
                                    <span className="placeholder col-6"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <>
            {isLoaded && error == null ? (
                <>
                    <div className="content-header">
                        <h1>
                            <span>수리실적 조회</span>
                        </h1>
                    </div>

                    <div className="container-fluid">
                        {/* KPI 섹션 */}
                        {!kpiLoaded || !kpiData ? (
                            <KPISkeleton />
                        ) : (
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div className="card card-outline card-primary">
                                        <div className="card-header">
                                            <h3 className="card-title">
                                                <i className="fas fa-chart-bar mr-2"></i>
                                                수리실적 현황
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                {/* 보일러대수 */}
                                                <div className="col-md-4">
                                                    <div className="info-box bg-primary">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-clipboard-list"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">보일러대수</span>
                                                            <span className="info-box-number text-white">
                                                                {(kpiData.boilerCount || 0).toLocaleString()}대
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 출장건수 */}
                                                <div className="col-md-4">
                                                    <div className="info-box bg-warning">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-truck"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">출장건수</span>
                                                            <span className="info-box-number text-white">
                                                                {(kpiData.tripCount || 0).toLocaleString()}건
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 견적금액 */}
                                                <div className="col-md-4">
                                                    <div className="info-box bg-success">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-won-sign"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">견적금액</span>
                                                            <span className="info-box-number text-white">
                                                                {PageUtil.formatToKRW(kpiData.inspectionAmount || 0)}원
                                                            </span>
                                                            <small className="text-white-50 d-block" style={{ fontSize: '0.7rem' }}>
                                                                (수리비+고객출장비)
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="row">

                                                {/* 수리원가 */}
                                                <div className="col-md-3">
                                                    <div className="info-box bg-danger">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-tools"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">수리원가</span>
                                                            <span className="info-box-number text-white">
                                                                {PageUtil.formatToKRW(kpiData.repairCost || 0)}원
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* ✅ 고객 청구 출장비 (수익) - 새로 추가 */}
                                                <div className="col-md-3">
                                                    <div className="info-box bg-primary">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-hand-holding-usd"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">출장비(고객)</span>
                                                            <span className="info-box-number text-white">
                                                                {PageUtil.formatToKRW(kpiData.tripFeeRevenue || 0)}원
                                                            </span>
                                                            <small className="text-white-50 d-block" style={{ fontSize: '0.7rem' }}>
                                                                수익
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 출장 비용 (출장자 지불) */}
                                                <div className="col-md-3">
                                                    <div className="info-box bg-info">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-car"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">출장비용(출장자)</span>
                                                            <span className="info-box-number text-white">
                                                                {PageUtil.formatToKRW(kpiData.tripCost || 0)}원
                                                            </span>
                                                            <small className="text-white-50 d-block" style={{ fontSize: '0.7rem' }}>
                                                                비용
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 이익 */}
                                                <div className="col-md-3">
                                                    <div className="info-box" style={{ backgroundColor: '#6c757d' }}>
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-chart-line"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">이익</span>
                                                            <span className="info-box-number text-white">
                                                                {PageUtil.formatToKRW(kpiData.profit || 0)}원
                                                            </span>
                                                            <small className="text-white-50 d-block" style={{ fontSize: '0.7rem' }}>
                                                                견적금액 - 비용
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* ✅ 추가: 계산 공식 안내 */}
                                            {/* <div className="row mt-3">
                                                <div className="col-12">
                                                    <div className="alert alert-info mb-0" style={{ fontSize: '0.85rem' }}>
                                                        <i className="fas fa-info-circle mr-2"></i>
                                                        <strong>계산 공식:</strong>
                                                        <span className="ml-2">
                                                            견적금액 = 수리비 + 출장비(고객) |
                                                            이익 = 견적금액 - (수리원가 + 출장비용(출장자) + 물류비)
                                                        </span>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* 검색 필터 */}
                        <SearchFilter
                            searchParams={search}
                            onSearchChange={handleSearchChange}
                            onSearch={onSearch}
                            onClearFilter={onClearFilter}
                            onClearManufactureMonthFilter={onClearManufactureMonthFilter}
                            showStatusFilter={true}
                            showTypeFilter={true}
                            showDateRange={true}
                            showDateType={true}
                            showManufactureMonthRange={true}
                            showModelName={true}
                            showRepairNote={true}
                            dateTypeOptions={dateTypeOptions}
                            placeholder="고객명, 연락처, 보일러명 등 검색"
                            onExcelDownload={handleExportExcel}
                        />

                        {/* 목록 */}
                        <div className="card card-outline card-dark">
                            <div className="card-header">
                                <div className="card-title">접수 목록</div>
                                <div className="card-tools">
                                    <span className="badge bg-secondary">
                                        {PageUtil.formatToKRW(params.total)} 건
                                    </span>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                {list.length === 0 ? (
                                    <NoData />
                                ) : (
                                    <table className="table text-nowrap">
                                        <thead>
                                            <tr>
                                                <th>처리상황</th>
                                                <th>처리유형</th>
                                                <th>접수일자</th>
                                                <th>연락처</th>
                                                <th>고객명</th>
                                                <th>보일러명</th>
                                                <th>제조년월</th>
                                                <th>특이사항</th>
                                                <th>수리내역</th>
                                                <th>접수내용</th>
                                                <th>처리내용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((row) => (
                                                <tr key={row.id}>
                                                    <td>
                                                        <span className="badge bg-secondary">
                                                            {params.statusSet.find(s => s.value === row.status)?.label || row.status}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span
                                                            className={"badge " + (row.type == ReceptionType.NEW_EXCHANGE || row.type == ReceptionType.EXCHANGE ? ' bg-danger' : 'bg-info')}
                                                            style={{ fontSize: '15px', padding: '5px 10px' }} // 글자 크기와 여백 추가
                                                        >
                                                            {getReceptionType().find((t) => t.value === row.type)?.label || row.type}
                                                        </span>
                                                    </td>
                                                    <td>{row.receivedDate || ''}</td>
                                                    <td>
                                                        <a onClick={() => onOpenEdit(row)} style={{ cursor: 'pointer' }}>
                                                            {row.phone1 || ''}
                                                        </a>
                                                    </td>
                                                    <td><strong>{row.customerName || ''}</strong></td>
                                                    <td>
                                                        <code>
                                                            {(row.items?.find(p => p.kind === ReceptionItemKind.BOILER)?.modelName || '') +
                                                                (row.items?.filter(p => p.kind === ReceptionItemKind.BOILER)?.length > 1 ? ' 外' : '')}
                                                        </code>
                                                    </td>
                                                    <td>
                                                        <small>{row?.items?.find(p => p.manufactureMonth)?.manufactureMonth || ''}</small>
                                                    </td>
                                                    <td>
                                                        <small className="text-warning">
                                                            {row.items?.filter(p => p.note).map(p => p.note).join(', ') || ''}
                                                        </small>
                                                    </td>
                                                    <td>
                                                        {row.repairNote && row.repairNote.length > 10
                                                            ? `${row.repairNote.substring(0, 10)}...`
                                                            : (row.repairNote || '')}
                                                    </td>
                                                    <td>
                                                        <small>
                                                            {row.requestNote && row.requestNote.length > 10
                                                                ? `${row.requestNote.substring(0, 10)}...`
                                                                : (row.requestNote || '')}
                                                        </small>
                                                    </td>
                                                    <td>
                                                        <small>
                                                            {row.handleNote && row.handleNote.length > 10
                                                                ? `${row.handleNote.substring(0, 10)}...`
                                                                : (row.handleNote || '')}
                                                        </small>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {list.length > 0 && (
                                <PaginationControl
                                    page={params.search.page}
                                    total={params.total}
                                    limit={params.search.rows}
                                    changePage={(page) => {
                                        const cur = PageUtil.deepCopy(params);
                                        cur.search.page = page;
                                        setParams(cur);
                                        setSearch(true);
                                    }}
                                    ellipsis={1}
                                />
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <Loading />
            )}
        </>
    );
};

export default RepairStatisticsV;